import { IStyle } from "./../../../Types/Style";
import { Action as ReduxAction, handleActions } from "redux-actions";

import { ICompleteOrganization, RequestState } from "../../types/common";
import { Action, IFirstFetchPayload } from "../actions";

export interface IState {
  addNewThemeStatus: RequestState;
  deleteThemeStatus: RequestState;
  fetchEditableThemesStatus: RequestState;
  fullOrganization: ICompleteOrganization | null;
  themes: IStyle[];
}

const INITIAL_STATE: IState = {
  addNewThemeStatus: RequestState.IDLE,
  deleteThemeStatus: RequestState.IDLE,
  fetchEditableThemesStatus: RequestState.IDLE,
  fullOrganization: null,
  themes: [],
};

const mount = (state: IState): IState => ({
  ...state,
  fetchEditableThemesStatus: RequestState.PENDING,
});

const handleFetchEdtiableThemesSuccess = (state: IState, action: ReduxAction<IFirstFetchPayload>): IState => ({
  ...state,
  fetchEditableThemesStatus: RequestState.SUCCEEDED,
  fullOrganization: action.payload.fullOrganization,
  themes: action.payload.styles,
});

const handleFetchEdtiableThemesFailure = (state: IState): IState => ({
  ...state,
  fetchEditableThemesStatus: RequestState.FAILED,
});

const deleteTheme = (state: IState): IState => ({
  ...state,
  deleteThemeStatus: RequestState.PENDING,
});

const handleDeleteThemeSuccess = (state: IState, action: ReduxAction<IStyle[]>): IState => ({
  ...state,
  deleteThemeStatus: RequestState.SUCCEEDED,
  themes: action.payload,
});

const handleDeleteThemeFailure = (state: IState): IState => ({
  ...state,
  deleteThemeStatus: RequestState.FAILED,
});

const unmount = (_: IState): IState => INITIAL_STATE;

const addNewTheme = (state: IState): IState => ({
  ...state,
  addNewThemeStatus: RequestState.PENDING,
});

const handleAddNewThemeFailure = (state: IState): IState => ({
  ...state,
  addNewThemeStatus: RequestState.FAILED,
});

const handleAddNewThemeSuccess = (state: IState): IState => ({
  ...state,
  addNewThemeStatus: RequestState.SUCCEEDED,
});

type Payload = IFirstFetchPayload | IStyle[] | { message: string } | void;

export default handleActions<IState, Payload>(
  {
    [Action.MOUNT]: mount,
    [Action.HANDLE_FETCH_EDITABLE_THEMES_SUCCESS]: handleFetchEdtiableThemesSuccess,
    [Action.HANDLE_FETCH_EDITABLE_THEMES_FAILURE]: handleFetchEdtiableThemesFailure,
    [Action.DELETE_THEME]: deleteTheme,
    [Action.HANDLE_DELETE_THEME_FAILURE]: handleDeleteThemeFailure,
    [Action.HANDLE_DELETE_THEME_SUCCESS]: handleDeleteThemeSuccess,
    [Action.ADD_NEW_THEME]: addNewTheme,
    [Action.HANDLE_ADD_NEW_THEME_FAILURE]: handleAddNewThemeFailure,
    [Action.HANDLE_ADD_NEW_THEME_SUCCESS]: handleAddNewThemeSuccess,
    [Action.UNMOUNT]: unmount,
  },
  INITIAL_STATE
);
